import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_PERMISSION_LISTING,
    ADD_PERMISSION,
    UPDATE_PERMISSION,
    DELETE_PERMISSION,
    EXPORT_PERMISSION,
    GET_PERMISSION_DETAILS,
} from "./actionTypes.js";

import {
    getPermissionListingSuccess,
    getPermissionListingFail,
    createPermissionSuccess,
    createPermissionFail,
    updatePermissionSuccess,
    updatePermissionFail,
    deletePermissionSuccess,
    deletePermissionFail,
    exportPermissionSuccess,
    exportPermissionFail,
    getPermissionDetailsSuccess,
    getPermissionDetailsFail,
} from "./actions.js";

import {
    permissionListingApi,
    updatePermissionApi,
    deletePermissionApi,
    exportPermissionApi,
    permissionDetailsApi,
    addPermissionApi,
} from "./permissionApi.js";

function* fetchPermissionListing({ payload }) {
    try {
        const response = yield call(permissionListingApi, payload);
        yield put(getPermissionListingSuccess(response));
    } catch (error) {
        yield put(getPermissionListingFail(error));
    }
}

function* fetchPermissionDetail({ payload }) {
    try {
        const response = yield call(permissionDetailsApi, payload);
        yield put(getPermissionDetailsSuccess(response));
    } catch (error) {
        yield put(getPermissionDetailsFail(error));
    }
}

function* createPermission({ payload }) {
    try {
        const response = yield call(addPermissionApi, payload);
        yield put(createPermissionSuccess(response));
    } catch (error) {
        yield put(createPermissionFail(error));
    }
}

function* updatePermission({ payload }) {
    try {
        const response = yield call(updatePermissionApi, payload);
        yield put(updatePermissionSuccess(response));
    } catch (error) {
        yield put(updatePermissionFail(error));
    }
}

function* deletePermission({ payload }) {
    try {
        const response = yield call(deletePermissionApi, payload);
        yield put(deletePermissionSuccess(response));
    } catch (error) {
        yield put(deletePermissionFail(error));
    }
}

function* exportPermission({ payload }) {
    try {
        const response = yield call(exportPermissionApi, payload);
        yield put(exportPermissionSuccess(response));
    } catch (error) {
        yield put(exportPermissionFail(error));
    }
}

function* PermissionSaga() {
    yield takeEvery(GET_PERMISSION_LISTING, fetchPermissionListing);
    yield takeEvery(GET_PERMISSION_DETAILS, fetchPermissionDetail);
    yield takeEvery(ADD_PERMISSION, createPermission);
    yield takeEvery(UPDATE_PERMISSION, updatePermission);
    yield takeEvery(DELETE_PERMISSION, deletePermission);
    yield takeEvery(EXPORT_PERMISSION, exportPermission);

}

export default PermissionSaga
